import flagSmith from "@flagsmith/flagsmith";
import { isInternalSupportUser, createAuth } from "src/services/auth";

const environmentID = process.env.REACT_APP_BULLET_TRAIN_ENVIRONMENT_ID;
const defaultFlags = {};

const loadFeatureFlags = (user) => {
  const { username, email } = createAuth(user);
  const isSupportUser = isInternalSupportUser(user);

  const cacheFlags = process.env.NODE_ENV !== "development";

  return new Promise((resolve) => {
    const resolveDefaults = () => resolve(defaultFlags);
    const cleanedUsername =
      username && username.includes("-")
        ? `${username.replace(/-/g, "")}fixed`
        : username;
    flagSmith
      .init({
        environmentID,
        // Support users with an email use it as their Flagsmith identity so
        // toggles can be targeted; otherwise fall back to the cleaned username.
        identity: (isSupportUser && email) || cleanedUsername,
        traits: {
          username: cleanedUsername,
          // email trait sent for everyone so email-based segments (e.g. the
          // backend-consistent debug-tabs gate) match any targeted user.
          ...(email && { email }),
        },
        defaultFlags,
        api: "https://edge.api.flagsmith.com/api/v1/",
        cacheFlags,
        cacheOptions: {
          ttl: 1000 * 3600 * 2, // 2 hours in ms
          skipAPI: true,
        },
        onError: resolveDefaults,
        onChange: () => {
          const featureFlags = flagSmith.getAllFlags();
          resolve(featureFlags);
        },
      })
      .catch(resolveDefaults);
  });
};

export default loadFeatureFlags;
